module.exports = __webpack_public_path__ + "img/bg-mision-2-25.0a4899d5.jpg";